import {
  Box,
  Grid,
  Typography,
  Button,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import React, { useState } from "react";
import { UserCommonStyles } from "../../styles/CommonStyles";
import LeftSidebar from "../../components/sidebars/LeftSidebar";
import { useTranslation } from "react-i18next";
import SocialIconSection from "../../components/sidebars/SocialIconSection";
import AdPaymentMethod from "./AdPaymentMethod";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import { toast } from "../../utils/toastsMessage";
import ClipLoader from "react-spinners/ClipLoader";

const stripePromise = loadStripe(
  process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || ""
);

const EstimationResultAndPaymentDetail: React.FC<any> = (props: any) => {
  const {
    paidOrUnpaidAmount,
    setPaidOrUnpaidAmount,
    totalAmount,
    setTotalAmount,
    budgetPerDay,
    isEdit,
    days,
    adCenterStep1Data,
    onSubmitAdData,
    setFormHandler,
  } = props;

  const commonStyle = UserCommonStyles();

  const [isDisabled, setIsDisabled] = useState<boolean>(false);
  const [isConfirm, setIsConfirm] = useState<any>({
    confirm: false,
    message: "",
  });

  const onSubmitWithoutStripe = () => {
    setIsDisabled(true);
    if (isEdit) {
      onSubmitAdData(null, null, setIsDisabled);
    } else {
      setIsDisabled(false);
      return toast.error("Something went wrong. Please try again later.");
    }
  };

  const cancelProduct = () => {
    // setGender("");
    // setMinAndMaxAgeSlider([0, 0]);
    // setInterestArray([]);
    // setLocationArray([]);
    setFormHandler({
      isShowStep1: false,
      isShowStep2: true,
      isShowStep3: false,
      isShowStep4: false,
    });
  };
console.log('paidOrUnpaidAmount :>> ', paidOrUnpaidAmount);
  return (
    <Box className={commonStyle.windowColor}>
      <Grid container>
        <Grid item md={3}>
          <LeftSidebar />
          {/* <SocialIconSection /> */}
        </Grid>
        <Grid item md={9}>
          <Box className={commonStyle.p20}>
            <Box className={`${commonStyle.mb15} ${commonStyle.mt30}`}>
              <Typography
                variant="h6"
                className={`${commonStyle.grey} ${commonStyle.fontWeight600} ${commonStyle.f_family_Roboto} ${commonStyle.font20}`}
              >
                Estimated daily result
              </Typography>
            </Box>
            <Box
              pt={6}
              pl={4}
              className={`${commonStyle.p20} ${commonStyle.card}`}
            >
              <Grid container spacing={10}>
                <Grid item lg={1} md={0} sm={0}></Grid>
                <Grid item lg={10} md={10} sm={12}>
                  {/* <p onClick={cancelProduct}>Back</p> */}
                  <Typography
                    variant="h6"
                    className={`${commonStyle.black} ${commonStyle.fontWeight400} ${commonStyle.f_family_Roboto} ${commonStyle.font24}`}
                  >
                    Payment summary
                  </Typography>
                  <Typography
                    mt={0.2}
                    variant="h6"
                    className={`${commonStyle.silver_Chalice} ${commonStyle.fontWeight300} ${commonStyle.f_family_Roboto} ${commonStyle.font18}`}
                  >
                    {`Your ad will run for ${
                      days?.current ? days?.current : "0"
                    } ${days?.current > 1 ? "days" : "day"}`}
                  </Typography>
                  <Box
                    mt={5}
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <Box>
                      <Typography
                        variant="h6"
                        className={`${commonStyle.black} ${commonStyle.fontWeight400} ${commonStyle.f_family_Roboto} ${commonStyle.font16}`}
                      >
                        Total Buget
                      </Typography>
                      <Typography
                        variant="h6"
                        className={`${commonStyle.black} ${commonStyle.fontWeight400} ${commonStyle.f_family_Roboto} ${commonStyle.font16}`}
                      >
                        {`$${paidOrUnpaidAmount?.dividedAmountPerDay !== 0 && budgetPerDay?.current ?
                        (paidOrUnpaidAmount?.dividedAmountPerDay + budgetPerDay?.current)?.toFixed(2) :
                          budgetPerDay?.current
                            ? budgetPerDay?.current.toFixed(2)
                            : "0.00"
                        } a day x ${days?.current ? days?.current : "0"} ${
                          days?.current > 1 ? "days" : "day"
                        }`}
                      </Typography>
                    </Box>
                    <Typography
                      variant="h6"
                      className={`${commonStyle.black} ${commonStyle.fontWeight600} ${commonStyle.f_family_Roboto} ${commonStyle.font18}`}
                    >
                      {paidOrUnpaidAmount?.unpaidAmount > 0 ||
                      paidOrUnpaidAmount?.paidAmount > 0
                        ? `$${(
                            paidOrUnpaidAmount?.unpaidAmount > 0 ? paidOrUnpaidAmount?.unpaidAmount +
                              paidOrUnpaidAmount?.paidAmount : paidOrUnpaidAmount?.paidAmount
                          ).toFixed(2)} USD`
                        : "$0.00 USD"}
                    </Typography>
                  </Box>
                  <Box
                    mt={3}
                    mb={3}
                    sx={{
                      width: "90%",
                      height: "1px",
                      backgroundColor: "#A0A0A0",
                      marginLeft: "auto",
                      marginRight: "auto",
                    }}
                  />

                  {isEdit ? (
                    <>
                      <Box
                        mt={3}
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <Box>
                          <Typography
                            variant="h6"
                            className={`${commonStyle.black} ${commonStyle.fontWeight400} ${commonStyle.f_family_Roboto} ${commonStyle.font16}`}
                          >
                            {"Paid amount"}
                          </Typography>
                        </Box>
                        <Typography
                          variant="h6"
                          className={`${commonStyle.black} ${commonStyle.fontWeight600} ${commonStyle.f_family_Roboto} ${commonStyle.font18}`}
                        >
                          {paidOrUnpaidAmount?.paidAmount
                            ? `$${(paidOrUnpaidAmount?.paidAmount).toFixed(
                                2
                              )} USD`
                            : "$0.00 USD"}
                        </Typography>
                      </Box>
                      <Box
                        mt={3}
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <Box>
                          <Typography
                            variant="h6"
                            className={`${commonStyle.black} ${commonStyle.fontWeight400} ${commonStyle.f_family_Roboto} ${commonStyle.font16}`}
                          >
                            {"Unpaid amount"}
                          </Typography>
                        </Box>
                        <Typography
                          variant="h6"
                          className={`${commonStyle.black} ${commonStyle.fontWeight600} ${commonStyle.f_family_Roboto} ${commonStyle.font18}`}
                        >
                          {paidOrUnpaidAmount?.unpaidAmount > 0
                            ? `$${(paidOrUnpaidAmount?.unpaidAmount).toFixed(
                                2
                              )} USD`
                            : "$0.00 USD"}
                        </Typography>
                      </Box>
                    </>
                  ) : (
                    ""
                  )}
                  <Box
                    mt={5}
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <Typography
                      variant="h6"
                      className={`${commonStyle.black} ${commonStyle.fontWeight500} ${commonStyle.f_family_Roboto} ${commonStyle.font22}`}
                    >
                      Total amount
                    </Typography>
                    <Typography
                      variant="h6"
                      className={`${commonStyle.black} ${commonStyle.fontWeight500} ${commonStyle.f_family_Roboto} ${commonStyle.font22}`}
                    >
                      {paidOrUnpaidAmount?.paidAmount ||
                      paidOrUnpaidAmount?.unpaidAmount > 0
                        ? `$${(
                          paidOrUnpaidAmount?.unpaidAmount > 0 ? paidOrUnpaidAmount?.unpaidAmount +
                          paidOrUnpaidAmount?.paidAmount : paidOrUnpaidAmount?.paidAmount
                          ).toFixed(2)} USD`
                        : "$0.00 USD"}
                    </Typography>
                  </Box>
                  {paidOrUnpaidAmount?.unpaidAmount > 0 ? (
                    <div style={{ marginTop: "20px" }}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            onChange={(e: any) =>
                              setIsConfirm({
                                confirm: e?.target?.checked,
                                message: "",
                              })
                            }
                            checked={isConfirm?.confirm}
                          />
                        }
                        label="The payment made for the ads is non-refundable"
                      />
                      {isConfirm?.message !== "" ? (
                        <p style={{ color: "red", fontSize: "14px" }}>
                          {isConfirm?.message}
                        </p>
                      ) : (
                        ""
                      )}
                    </div>
                  ) : (
                    ""
                  )}
                </Grid>
                <Grid item lg={1} md={0} sm={0}></Grid>
                <Grid item lg={1} md={0} sm={0}></Grid>

                <Grid item lg={10} md={10} sm={12}>
                  {paidOrUnpaidAmount?.unpaidAmount > 0 ? (
                    <Elements stripe={stripePromise}>
                      <AdPaymentMethod
                        totalAmount={totalAmount}
                        budgetPerDay={budgetPerDay}
                        isEdit={isEdit}
                        days={days}
                        adCenterStep1Data={adCenterStep1Data}
                        onSubmitAdData={onSubmitAdData}
                        isDisabled={isDisabled}
                        isConfirm={isConfirm}
                        setIsConfirm={setIsConfirm}
                        setIsDisabled={setIsDisabled}
                      />
                    </Elements>
                  ) : isEdit && paidOrUnpaidAmount?.unpaidAmount === 0 ? (
                    <Box mt={4} mb={10} className={` ${commonStyle.blueBtn} `}>
                      <Button
                        fullWidth
                        disabled={isDisabled}
                        style={{
                          fontFamily: "Roboto",
                          fontWeight: "500",
                          fontSize: "20px",
                          alignItems: "center",
                          color: "#fff",
                        }}
                        onClick={onSubmitWithoutStripe}
                      >
                        Publish{isDisabled ? <ClipLoader /> : null}
                      </Button>
                    </Box>
                  ) : (
                    ""
                  )}

                  {/* <Grid container spacing={3} mt={0.5} >
                                        <Grid item md={12}>
                                            <Box className={commonStyle.commonInput}>
                                                <Typography
                                                    className={commonStyle.labelCommonInput}
                                                >
                                                    Card Number
                                                </Typography>
                                                <TextField
                                                    placeholder={"xxxxx-xxxx-xxxx-xxxx"}
                                                    className={commonStyle.w100}
                                                />
                                                <span className={commonStyle.errorMsg}>
                                                </span>
                                            </Box>
                                        </Grid>

                                        <Grid item lg={6} md={6} sm={12}>
                                            <Box className={commonStyle.commonInput}>
                                                <Typography
                                                    className={commonStyle.labelCommonInput}
                                                >
                                                    Expiry Date
                                                </Typography>
                                                <TextField
                                                    placeholder={"06/26"}
                                                    variant="outlined"
                                                    className={commonStyle.w100}
                                                />
                                            </Box>
                                        </Grid>

                                        <Grid item lg={6} md={6} sm={12}>
                                            <Box className={commonStyle.commonInput}>
                                                <Typography
                                                    className={commonStyle.labelCommonInput}
                                                >
                                                    CVC
                                                </Typography>
                                                <TextField
                                                    variant="outlined"
                                                    className={commonStyle.w100}
                                                />
                                            </Box>
                                        </Grid>
                                        <Grid item lg={12} md={12} sm={12}>
                                            <Box
                                                className={` ${commonStyle.blueBtn} `}
                                            >
                                                <Button
                                                    fullWidth
                                                    // className={commonStyle.checkout_btn}
                                                    style={{
                                                        fontFamily: "Roboto",
                                                        fontWeight: "500",
                                                        fontSize: "20px",
                                                        alignItems: "center",
                                                        color: "#fff"
                                                    }}
                                                    onClick={() => history.push(RoutingLinks.adlist)}
                                                >
                                                    Publish
                                                </Button>
                                            </Box>
                                        </Grid>
                                    </Grid> */}
                </Grid>
                <Grid item lg={1} md={0} sm={0}></Grid>
              </Grid>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default EstimationResultAndPaymentDetail;
